/**
 * (c) LBS logics
 *
 *     Mobile Business Technology GmbH
 *     4020 Linz, Austria
 *
 *     www.lbs-logics.com
 *
 *     created on 20190902 by Jan Brunner
 *     all rights reserved.
 */

import { Injectable } from '@angular/core';
import { CargoItem } from 'src/app/_model/cargo-item';
import { Resetable } from '../../resetter/resetable';

@Injectable()
export abstract class CargoItemsDaoService implements Resetable {
  public abstract saveCargoItems(cargoItems: CargoItem[]): Promise<void>;
  public abstract getCargoItems(): Promise<CargoItem[]>;
  public abstract createCargoItem(cargoItem: CargoItem): Promise<CargoItem>; 
  public abstract reset(): Promise<void>;
  public abstract clear(): Promise<void>;
}